import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
import { formatDate } from '../../utils/format';
import type { Article } from '../../types/content';
type ArticleCardProps = {
  article: Article;
  variant?: 'default' | 'feature';
  image?: string;
};
export function ArticleCard({
  article,
  variant = 'default',
  image
}: ArticleCardProps) {
  if (variant === 'feature') {
    return <article className="group relative flex h-full min-h-[420px] flex-col justify-end overflow-hidden rounded-xl bg-midnight p-8 md:p-10" data-id="element-327" data-mp="1bwnj4w0d6e2u">
        {image && <img src={image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-40 transition-transform duration-300 ease-premium group-hover:scale-[1.02]" data-id="element-328" data-mp="1lvv0rve4suvr" />}
        <div className="absolute inset-0 bg-midnight/50" aria-hidden="true" data-id="element-329" data-mp="3nnrjboypv501" />
        <div className="relative" data-id="element-330" data-mp="3ippz30pk0zmz">
          <p className="text-sm font-medium text-gold-300" data-id="element-331" data-mp="3iqrc3aq4rw7c">{article.category}</p>
          <h3 className="mt-3 max-w-xl font-display text-3xl font-semibold leading-tight text-white md:text-4xl" data-id="element-332" data-mp="vjy9sqeka5m0">
            <Link to={`/insights/${article.slug}`} className="after:absolute after:inset-0" data-id="element-333" data-mp="zhcimgybybdh">
              {article.title}
            </Link>
          </h3>
          <p className="mt-4 max-w-lg leading-relaxed text-white/75" data-id="element-334" data-mp="19ajtuifr4llh">{article.excerpt}</p>
          <p className="mt-6 flex items-center gap-2 text-sm text-white/60" data-id="element-335" data-mp="1e9eg5ucxgsac">
            <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-336" data-mp="1j7fyue6fypla" />
            {article.readMinutes} min read · {formatDate(article.date)}
          </p>
        </div>
      </article>;
  }
  return <article className="group relative flex h-full flex-col border-t border-line pt-6" data-id="element-337" data-mp="1s849r00jg9ty">
      <p className="text-sm font-medium text-gold-700" data-id="element-338" data-mp="3p0o15wn7yqpu">{article.category}</p>
      <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-ink transition-colors duration-150 group-hover:text-royal" data-id="element-339" data-mp="3p2r0j7a9hw78">
        <Link to={`/insights/${article.slug}`} className="after:absolute after:inset-0" data-id="element-340" data-mp="114qyixd8btn3">
          {article.title}
        </Link>
      </h3>
      <p className="mt-3 leading-relaxed text-muted" data-id="element-341" data-mp="w7qsgmgdqqvz">{article.excerpt}</p>
      <p className="mt-auto flex items-center gap-2 pt-5 text-sm text-muted" data-id="element-342" data-mp="1a706pgl0zaxb">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-343" data-mp="156cj74w09c7u" />
        {article.readMinutes} min read · {formatDate(article.date)}
      </p>
    </article>;
}